import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Dialer from './Dialer';
import {
  Routes,
  Route,
  BrowserRouter as Router
} from "react-router-dom";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Note: StrictMode removed to prevent double-mounting which interferes with SIP connections
root.render(
  <Router>
    <Routes>
      <Route path='/dialer' element={<Dialer />} />
      <Route path='*' element={<App />} />
    </Routes>
  </Router>
);

